import type { StyleRule } from '@archipro-design/aria';
import {
    containerClassName,
    pxArrayToRem,
    pxToRem,
} from '@archipro-design/aria';

export const ArticleFooterContainer: StyleRule = ({ theme }) => ({
    gap: pxToRem(64),
    paddingTop: pxToRem(40),

    [theme.screen.laptop]: {
        gap: pxToRem(160),
        paddingTop: pxToRem(96),
        ['& .' + containerClassName]: {
            '&:not(:empty)': {
                paddingBottom: pxToRem(224),
            },
        },
    },
});

export const ArticleFooterMagazineSection: StyleRule = () => ({
    background: '#0D0E12',
});

export const MobileFooterDivider: StyleRule = () => ({
    marginBottom: pxToRem(40),
});

export const ArticlesCarouselDesktopClass: StyleRule = () => ({
    paddingBottom: pxToRem(32),
    marginBottom: pxToRem(32),
});

export const TopReadArticlesDesktopClass: StyleRule = () => ({
    marginBottom: pxToRem(64),
});

export const ArticleFooterEnquiryContainer: StyleRule = ({ theme }) => ({
    margin: pxArrayToRem([100, 16, 54, 16]),
    '& textArea': {
        maxHeight: pxToRem(134),
    },
    [theme.screen.laptop]: {
        marginRight: 'auto',
        marginLeft: 'auto',
        marginTop: 'auto',
        maxHeight: 'unset',
        width: pxToRem(900),
        marginBottom: pxToRem(175),
    },

    '>div': {
        paddingTop: 0,
    },
});
